import { FC } from 'react'
import { Button } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'

import useRFQModal from '../../Modals/hooks/useRFQModal'
import useGetAnalyticsLocation from '../../../services/analytics/useGetAnalyticsLocation'
import { AnalyticsSubLocation } from '../../../utils/types/analytics'

import buttonStyles from '../../../styles/CustomButtons.module.less'

const RfqButton: FC = () => {
  const { t } = useTranslation('modals')
  const analyticsLocation = useGetAnalyticsLocation(AnalyticsSubLocation.EmptyState)
  const openRfqModal = useRFQModal({ analyticsLocation })

  return (
    <Button
      appearance="primary"
      className={`${buttonStyles['custom-button']}
                  ${buttonStyles['button-primary']}
                  ${buttonStyles['button-caret']} margin-top-spacer-double padding-top-spacer-half`}
      size="lg"
      onClick={() => openRfqModal()}
    >
      {t('Request a quote')}
    </Button>
  )
}

export default RfqButton
